<template>
  <div
    :id="'card-item-' + content.id"
    class="download-card card-item"
  >
    <div
      class="download-card__link"
      @click="download(content)"
    >
      <div class="download-card__header">
        <h3 v-html="content.title" />

        <i class="download-card__icon">
          <svg
            xmlns="http://www.w3.org/2000/svg"
            width="20"
            height="19"
            viewBox="0 0 20 19"
          >
            <g fill-rule="evenodd">
              <path
                class="animate-arrow"
                d="M14.414 7.707L13 6.293l-2.293 2.293V0h-2v8.586L6.414 6.293 5 7.707l4.707 4.708z"
              />
              <path
                class="animate-base"
                d="M18 17H2v-3h3.586l2 2h4.828l2-2H18v3zm-4.414-5l-2 2H8.414l-2-2H0v7h20v-7h-6.414z"
              />
            </g>
          </svg>
        </i>
      </div>
      <div class="download-card__content">
        <p v-html="content.description" />
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'

export default {
  name: 'DownloadCard',
  props: {
    content: Object
  },
  methods: {
    pushEventToAnalytics(action) {
      this.$analytics.pushAnalyticsEvent('ga-event', {
        category: 'Central de Ajuda',
        action: action,
        'id-user': this.profile.id,
        'id-lab': this.profile.id_laboratory,
        'name-lab': this.profile.laboratoryName
      })
    },
    download(data) {
      window.location = data.url
      this.pushEventToAnalytics('Downloads - ' + data.title)
    }
  },
  computed: {
    ...mapGetters(['profile'])
  }
}
</script>

<style lang="scss">
@import '../../../static/stylesheets/variables';

.download-card {
  width: calc(50% - 15px);
  margin-bottom: 20px;

  &:nth-child(odd) {
    margin-right: 30px;
  }

  &__content {
    font-style: normal;
    font-weight: normal;
    font-size: 14px;
    line-height: 16px;
    color: #7a7a7a;
    min-height: 50px;
  }

  &__header {
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin-bottom: 15px;

    h3 {
      font-weight: 700;
      font-size: 18px;
      line-height: 21px;
      color: #7f1a54;
      width: calc(100% - 62px);
    }
  }

  &__icon {
    display: flex;
    height: 40px;
    width: 40px;
    background: #7f1b54;
    justify-content: center;
    align-items: center;
    border-radius: 50%;

    svg {
      height: 100%;
    }

    g {
      fill: #fff;
    }

    .animate-arrow {
      position: absolute;
    }
  }

  &__link {
    background-color: #fff;
    border-radius: 5px;
    padding: 20px;
    cursor: pointer;
    box-shadow: 0 0 10px 0 rgba(0, 0, 0, 0.06);
    transition: all ease-in 0.2s;

    &:hover,
    &:focus {
      background-color: #ececec;
      box-shadow: 0 0 10px 2px rgba(0, 0, 0, 0.08);

      svg {
        .animate-arrow {
          animation: animateArrow 1.3s ease infinite;
        }
      }
    }
  }
}

@keyframes animateArrow {
  0% {
    transform: translateY(0);
  }
  50% {
    transform: translateY(-4px);
  }
  100% {
    transform: translateY(0);
  }
}
</style>
